
import React from 'react';

interface ParticipantAudioIndicatorProps {
  isMuted: boolean;
  audioLevel?: number; // Make it optional with default value
}

const ParticipantAudioIndicator: React.FC<ParticipantAudioIndicatorProps> = ({ 
  isMuted, 
  audioLevel = 0 // Default to 0 if not provided
}) => {
  if (isMuted) {
    return null;
  }
  
  // Use audioLevel to dynamically determine the height of bars
  const getBarHeight = (index: number): number => {
    // Base height plus random variation based on audio level
    const baseHeight = 10;
    const maxAdditionalHeight = audioLevel * 25 || 20; // Scale audioLevel to a reasonable height range
    return baseHeight + Math.random() * maxAdditionalHeight;
  };
  
  return (
    <div className="absolute bottom-16 left-0 right-0 flex justify-center z-20">
      <div className="flex items-end gap-[2px]">
        {Array.from({ length: 12 }).map((_, i) => (
          <div 
            key={i}
            className="w-[3px] bg-green-500 rounded-full"
            style={{ 
              height: `${getBarHeight(i)}px`,
              animationDelay: `${i * 0.1}s`,
              animation: 'pulse 1s infinite'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ParticipantAudioIndicator;
